import React from "react";
import { motion } from "framer-motion";

const images = [
  {
    src: "https://customer-assets.emergentagent.com/job_postpartum-care-7/artifacts/79s1lto6_D2REnYycoQbO5OsgTGm22_zf5n5TtL_00001.jpg",
    alt: "Michele wiegt das Neugeborene während die Eltern zuschauen",
    span: "md:col-span-7 md:row-span-2",
    h: "h-[500px] md:h-full",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_postpartum-care-7/artifacts/q2f63ac7_4YzSB1JVLRyJVAtFDxS4q_Esd6OlLa_00001.jpg",
    alt: "Familie badet das Baby gemeinsam mit Michele",
    span: "md:col-span-5",
    h: "h-[240px]",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_postpartum-care-7/artifacts/qbraxlgc_ILhD2PKAQTCc--8qjI4Fu_V4HCAvab_00001.jpg",
    alt: "Stillberatung auf dem Sofa",
    span: "md:col-span-5",
    h: "h-[240px]",
  },
];

export default function Gallery() {
  return (
    <section id="galerie" className="relative py-24 sm:py-32 bg-[#FDFBF7]" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-14 gap-4">
          <div>
            <p className="eyebrow mb-6">Einblick in meine Arbeit</p>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl text-[#2A332C] leading-[1.05] max-w-xl">
              Momente voller <br />
              <span className="font-display-italic text-[#A66B56]">Wärme & Stille</span>.
            </h2>
          </div>
          <p className="text-[#5C6B5E] max-w-sm">
            Die ersten Wochen als Familie sind kostbar – ich freue mich, euch in dieser besonderen Zeit begleiten zu dürfen.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-5 md:auto-rows-[240px]">
          {images.map((img, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              className={`overflow-hidden rounded-[2rem] ${img.span} ${img.h}`}
              data-testid={`gallery-image-${i}`}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
